import { render, staticRenderFns } from "./Logos.html?vue&type=template&id=94736ad2&scoped=true&"
import script from "./Logos.js?vue&type=script&lang=js&"
export * from "./Logos.js?vue&type=script&lang=js&"
import style0 from "./Logos.scss?vue&type=style&index=0&id=94736ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94736ad2",
  null
  
)

export default component.exports